import React from 'react'

function style1() {
    return (
            <svg xmlns="http://www.w3.org/2000/svg" width="86" height="41" viewBox="0 0 86 41">
            <defs>
            </defs>
            <g transform="translate(-12 -705)">
            <g className="a" fill="#fff" strokeMiterlimit="10" transform="translate(12 705)">
            <path className="e" stroke="none" d="M 84 40.5 L 2 40.5 C 1.172899961471558 40.5 0.5 39.82709884643555 0.5 39 L 0.5 2 C 0.5 1.172899961471558 1.172899961471558 0.5 2 0.5 L 84 0.5 C 84.82710266113281 0.5 85.5 1.172899961471558 85.5 2 L 85.5 39 C 85.5 39.82709884643555 84.82710266113281 40.5 84 40.5 Z"/>
            <path className="f" stroke="none" fill="none" d="M 2 1 C 1.448600769042969 1 1 1.448600769042969 1 2 L 1 39 C 1 39.55139923095703 1.448600769042969 40 2 40 L 84 40 C 84.55139923095703 40 85 39.55139923095703 85 39 L 85 2 C 85 1.448600769042969 84.55139923095703 1 84 1 L 2 1 M 2 0 L 84 0 C 85.10457611083984 0 86 0.8954277038574219 86 2 L 86 39 C 86 40.10457229614258 85.10457611083984 41 84 41 L 2 41 C 0.8954238891601562 41 0 40.10457229614258 0 39 L 0 2 C 0 0.8954277038574219 0.8954238891601562 0 2 0 Z"/>
            </g>
            <g className="b" strokeWidth="0.5px" stroke="#acacac" fill="none" transform="translate(22 715)">
            <rect className="e" stroke="none" width="67" height="26"/>
            <rect className="g" fill="none" x="0.25" y="0.25" width="66.5" height="25.5"/>
            </g>
            <g className="c" fill="#efefef" strokeWidth="0.5px" stroke="#acacac" transform="translate(22 710)">
            <rect className="e" stroke="none" width="67" height="7"/>
            <rect className="g" fill="none" x="0.25" y="0.25" width="66.5" height="6.5"/>
            </g>
            <g className="d" stroke="#0072c6" fill="#efefef" strokeWidth="0.5px" transform="translate(22 716)">
            <rect className="e" stroke="none" width="67" height="1"/>
            <rect className="g" fill="none" x="0.25" y="0.25" width="66.5" height="0.5"/>
            </g>
            </g>
            </svg>
    )
}

export default style1
